export default __webpack_public_path__ + "static/media/KY.b84eaab0.svg";